module.exports = __webpack_public_path__ + "files/4a5d787366f67407794a100e42fdf7ae.png";